import React, { useState } from 'react';
import { login } from '../services/authService';
import logo from '../assets/E-PresensiPkl.png'; // Ganti sesuai path logo kamu

function LoginPage() {
  const [nisn, setNisn] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const result = await login(nisn, password);
    setMessage(result.message);
    setIsSuccess(result.success);
    setIsLoading(false);

    if (result.success) {
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    }
  };

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="col-12 col-sm-10 col-md-6 col-lg-4">
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" className="img-fluid" style={{ maxWidth: '180px' }} />
        </div>

        {/* Alert */}
        {message && (
          <div className={`alert ${isSuccess ? 'alert-success' : 'alert-danger'} rounded-3 shadow-sm`} role="alert">
            {message}
          </div>
        )}

        {/* Login Card */}
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body p-4">
            <h5 className="mb-4 text-center fw-semibold">Masuk ke Akun Anda</h5>
            <form onSubmit={handleLogin}>
              {/* NISN */}
              <div className="mb-3">
                <label htmlFor="nisn" className="form-label">NISN</label>
                <div className="input-group">
                  <span className="input-group-text"><i className="bi bi-person-fill"></i></span>
                  <input
                    type="text"
                    id="nisn"
                    className="form-control"
                    placeholder="Masukkan NISN"
                    value={nisn}
                    onChange={(e) => setNisn(e.target.value)}
                    required
                  />
                </div>
              </div>

              {/* Password */}
              <div className="mb-4">
                <label htmlFor="password" className="form-label">Password</label>
                <div className="input-group">
                  <span className="input-group-text"><i className="bi bi-lock-fill"></i></span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    className="form-control"
                    placeholder="Masukkan Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="input-group-text"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                  </span>
                </div>
              </div>

              {/* Button */}
              <button
                type="submit"
                className="btn btn-primary w-100 rounded-pill fw-bold d-flex justify-content-center align-items-center"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Memproses...
                  </>
                ) : (
                  'Masuk'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
